/*************************************************/
/* ACCORDION-IMAGES                              */
/*************************************************/
import customEventsNames from '../customEventsNames';
export function accordionImages() {
    const accordionImagesContainerSelector = ".accordion-images__images-container";
    const accordionImageSelector = ".accordion-images__image";
    const accordionImageActiveClass = "accordion-images__image--active";
    const accordionImageFallbackClass = "accordion-images__image--fallback";

    const init = () => {
        const imageContainers = document.querySelectorAll(accordionImagesContainerSelector);
        if(imageContainers) {
            imageContainers.forEach(container => {
                container.addEventListener(customEventsNames.accordionActivateItemEventName,e => {
                    let i = 0;
                    container.querySelectorAll(accordionImageSelector).forEach(image => {
                        image.classList.remove(accordionImageActiveClass);
                        if(image.classList.contains(accordionImageFallbackClass)) return;
                        if(i == e.detail.accordionItemIndex) {
                            image.classList.add(accordionImageActiveClass);
                        }
                        i++;
                    });
                });
            });
        }
    };

    init();
}